export default __webpack_public_path__ + "static/media/LogoWeb.456cf011.png";